angular.module("rightPaneModule")
  .directive("activityFeedStandard", ['$state', 'translateFilter', 'customer', function($state, translateFilter, $customer) {
    // @TODO: This directive is used in both the new and old activity cards. It should be moved into
    // right-pane/components/activity-feed probably when we start to display the new cards
    // on the student and guardian feeds.

    return {
      restrict: "E",
      templateUrl: '/resources/right-pane/partials/activity-feed-standard.html',
      scope: {
        standard: '=standard',
        eid: '=eid'
      },
      link : function(scope, $elem, $attr) {
        // This could get expensive
        // @TODO: Move this into the classroom/student controllers and pass it in
        var academic_standard = $customer.getAcademicStandard();
        var academic_standard_name = academic_standard.academic_standard_name;

        switch(academic_standard_name){
          case 'dbl':
            scope.label = translateFilter('activity.viewProgress');
            break;
          default:
            scope.label = scope.standard.name;
        }

        var goToState = 'student';

        var params = _.pick($state.params, ['districtId', 'schoolId', 'teacherId', 'classroomId', 'breadcrumbs']);
        params.pane = 'standards';
        params.standards = scope.standard.level_id + 'g,' + scope.standard.domain_id + 'd,' + scope.standard.name_id + 's';
        params.studentId = scope.eid;

        if ($state.current.name === 'classroom') {
          goToState = $state.current.name;
        }
        else if ($state.current.name === 'guardian') {
          goToState = 'guardian';
          params.studentId = $state.params.studentId;
          params.customerId = $state.params.customerId;
          params.studentDistrictId = $state.params.studentDistrictId;
        }

        scope.standardsPaneURL = $state.href(goToState, params, {});
      }
    };
  }]);
